import React from "react";

export default function ThankYou() {
    return (
        <div id="pageContainer">
            <h2>
                Thank you for applying
                <br /> Chagrin Valley Early Learning Center!
            </h2>
            <br />
            <i className="fa fa-heart fa-5x" id="heart" aria-hidden="true"></i>
        </div>
    );
}
